import _classCallCheck from "/Users/rwithik/projects/rwithik.github.io/node_modules/@babel/runtime/helpers/esm/classCallCheck";
export var EmailJSResponseStatus = function EmailJSResponseStatus(httpResponse) {
  _classCallCheck(this, EmailJSResponseStatus);

  this.status = httpResponse.status;
  this.text = httpResponse.responseText;
};